import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const CompanyPage = lazy(() => import('../pages/company/page'));
const RecruitPage = lazy(() => import('../pages/recruit/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/company',
    element: <CompanyPage />,
  },
  {
    path: '/recruit',
    element: <RecruitPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
